import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(group => ({
        value: group.id,
        label: permission.name,
      }))
    },
    getSelectedItemsGroup(state) {
      return state.items.map(group => ({
        value: group.id,
        label: group.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/groups', { params })

      if (!data) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/groups', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/groups/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/groups/${id}`)

      return data
    },
    async show(_, id){
      const {data} = await axios.get(`v1/groups/${id}`)

      return data;
    },
    async assignCameras(_, params) {
      const { data } = await axios.post("v1/group/assign_cameras", params);
      return data;
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
